import React, { useCallback, useMemo } from 'react';
import { Form, Formik } from 'formik';
import { bool } from 'prop-types';
import { useHistory } from 'react-router-dom';

import { BlockWrap } from '../../atoms';
import { formFields, formNames, initialValues } from './schema';
import { FieldsWrapper } from '../formStyles';
import Input from '../_common/Input';
import { SELECT_OPTIONS, CUSTOM_SELECT_PROPS } from './consts';
import { isDefined } from '../../../utils/helpers';
import { useRegistrationStorage } from '../../../hooks/registration';
import { ONBOARDING_STATUS, ONBOARDING_STATUS_WITH_ROUTES } from '../../../constants/registration';
import { UI_ROUTES } from '../../../constants/routes';
import validator from './validator';
import CustomCheckboxes from '../_common/CustomCheckboxes';
import SignUpFooter from '../SignUpPersonalDetailsForm/SignUpFooter';

const COMPONENTS_MAP = {
  [formNames.companyMarkets]: CustomCheckboxes,
};

const COMPONENTS_PROPS_MAP = {
  [formNames.companyMarkets]: [],
};

const SignUpMarketsForm = () => {
  const [registrationSession, setRegistrationSession] = useRegistrationStorage();
  const { push } = useHistory();

  const handleSubmit = useCallback(
    (values) => {
      setRegistrationSession({
        ...registrationSession,
        [ONBOARDING_STATUS.companyDetails]: values,
        onboardingStatus: ONBOARDING_STATUS.paymentCurrency,
      });
      push(UI_ROUTES.signUpCurrency);
    },
    [setRegistrationSession, registrationSession, push]
  );

  const previousScreen = useMemo(() => {
    if (registrationSession.COMPANY_DETAILS.acceptingPayments === 'YES') {
      return ONBOARDING_STATUS_WITH_ROUTES.transactionsAmount;
    }
    if (registrationSession.COMPANY_DETAILS.paymentProcessor === 'YES') {
      return ONBOARDING_STATUS_WITH_ROUTES.paymentProcessors;
    }
    return ONBOARDING_STATUS_WITH_ROUTES.paymentProcessor;
  }, [registrationSession]);

  const parsedInitialValues = {
    ...initialValues,
    ...(registrationSession?.[ONBOARDING_STATUS.companyDetails] ?? {}),
  };

  return (
    <BlockWrap margin="37px 0 0">
      <FieldsWrapper>
        <Formik initialValues={parsedInitialValues} validate={validator} onSubmit={handleSubmit} validateOnBlur>
          <Form>
            {formFields.map(({ field, type, label, ...rest }, index) => {
              const Component = COMPONENTS_MAP[field] || Input;
              const addCustomMargin = field === formNames.companySize;

              return (
                <Component
                  key={field}
                  name={field}
                  {...(isDefined(SELECT_OPTIONS[field]) && {
                    options: SELECT_OPTIONS[field],
                    ...CUSTOM_SELECT_PROPS,
                  })}
                  type={type}
                  label={label}
                  index={index}
                  {...COMPONENTS_PROPS_MAP[field]}
                  {...rest}
                  {...(addCustomMargin && {
                    errorProps: {
                      margin: '6px 0 14px 0',
                    },
                  })}
                />
              );
            })}

            <SignUpFooter primaryButtonText="common.continueText" previousRoute={previousScreen} />
          </Form>
        </Formik>
      </FieldsWrapper>
    </BlockWrap>
  );
};

SignUpMarketsForm.propTypes = { loading: bool };

SignUpMarketsForm.defaultProps = { loading: false };

export default SignUpMarketsForm;
